import { Controller } from "@hotwired/stimulus";

const STORAGE_KEY = "franchise_rewrite_prompt";

export default class extends Controller {
  static targets = ["modal", "textarea"];
  static values = { default: String };

  connect() {
    const saved = localStorage.getItem(STORAGE_KEY);
    this.textareaTarget.value = saved || this.defaultValue;

    // Intercept all inject requests to append the custom prompt
    document.addEventListener("turbo:before-fetch-request", this.injectPrompt);
  }

  disconnect() {
    document.removeEventListener("turbo:before-fetch-request", this.injectPrompt);
  }

  toggle() {
    this.modalTarget.classList.toggle("hidden");
    if (!this.modalTarget.classList.contains("hidden")) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }

  save() {
    localStorage.setItem(STORAGE_KEY, this.textareaTarget.value);
    this.toggle();
  }

  reset() {
    this.textareaTarget.value = this.defaultValue;
    localStorage.removeItem(STORAGE_KEY);
  }

  injectPrompt = (event) => {
    const url = event.detail.fetchOptions.body
      ? null
      : event.detail.url?.toString();

    // Only inject for POST requests to /inject with text sections
    const fetchUrl = event.detail.url?.toString() || "";
    if (!fetchUrl.includes("/inject")) return;
    if (!fetchUrl.includes("section=identite") &&
        !fetchUrl.includes("section=recrutement")) return;

    const prompt = localStorage.getItem(STORAGE_KEY);
    if (!prompt) return;

    // Append system_prompt to the URL
    const separator = fetchUrl.includes("?") ? "&" : "?";
    event.detail.url = new URL(
      fetchUrl + separator + "system_prompt=" + encodeURIComponent(prompt),
    );
  };
}
